import { useLazyQuery } from '@apollo/client';
import { useQuery } from './useQuery';
import getSEOGeneratedContentQuery from '../queries/seolinks/getSEOGeneratedContent';

const useSEOGeneratedContent = ({
  nvalue,
  ssr = true,
  skip = false,
  lazy = false
}) => {
  const Query = getSEOGeneratedContentQuery();

  const opts = {
    ssr,
    skip,
    errorPolicy: 'all',
    variables: {
      nvalue,
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useSEOGeneratedContent;
